import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Navbar.css';

function Navbar() {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <Link to="/" className="logo">
          <h2>🤲 Alhamdulillah</h2>
        </Link>
        <div className="nav-links">
          <a href="#home">{t('nav.home')}</a>
          <a href="#features">{t('nav.features')}</a>
          <a href="#download">{t('nav.download')}</a>
          <Link to="/contact">{t('nav.contact')}</Link>
          <button className="lang-toggle" onClick={toggleLanguage}>
            {i18n.language === 'en' ? 'FR' : 'EN'}
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
